import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import TakeIcon from "./Icons/TakeIcon";
import DucksIcon from "./Icons/DucksIcon";
import DealDucksIcon from "./Icons/DealDucksIcon";
import Divider from "./Divider";
import { getItemByName, getItemBySizeAndPower } from "./Functions";
import shopItems from "./shopItems";
import { shopBuyPhrases, shopNotEnoughPhrases } from "./ShopPhrases";
import { useSocket } from "./SocketContext";

const Shop = ({
  t,
  audioManager,
  setNowOpen,
  dispatch,
  localProfile,
  addToast,
  changeDealDucks,
  setSortedItems,
}) => {
  const { emit, on, off, once, isConnected } = useSocket();
  const handleBuy = async (currency) => {
    try {
      setActiveShopItem(null); // Сбрасываем активный предмет
      setShopBuyButtonDisabled(true); // Блокируем кнопку покупки
      setActiveShopItemQuantity(1); // Сбрасываем количество предметов

      // Определяем стоимость в зависимости от валюты
      const cost =
        currency === "ducks"
          ? activeShopItem.cost * activeShopItemQuantity
          : activeShopItem.ddCost * activeShopItemQuantity;

      console.log("Emitting purchaseItem:", {
        playerId: localProfile.id,
        item: { title: activeShopItem.title, quantity: activeShopItemQuantity },
        cost: cost,
        currency: currency,
      });

      // Если покупается "autospin", сначала списываем dealDucks
      if (activeShopItem.type === "autospin" && localProfile.autospin) {
        addToast(t("You already have an autospin"), "error");
        setShopBuyButtonDisabled(false);
        return;
      }

      if (activeShopItem.type === "autospin" && !localProfile.autospin) {
        const success = await changeDealDucks(-280, "Purchase autospin BOT");
        if (!success) {
          setShopBuyButtonDisabled(false);
          return;
        }

        // Если успешно списались dealDucks, включаем autospin
        emit("autospinOn", { playerId: localProfile.id });
        dispatch({ type: "UPDATE_AUTOSPIN", payload: true });
        setShopBuyButtonDisabled(false);
        addToast(t("An autospin bot has been activated"), "success");
        return;
      }

      // Обычная покупка через socket
      off("purchaseSuccess");
      off("purchaseError");

      emit("purchaseItem", {
        playerId: localProfile.id,
        item: {
          title: activeShopItem.title,
          quantity: activeShopItemQuantity,
          type: activeShopItem.type,
        },
        cost: cost,
        currency: currency,
      });

      // Обработка успешного обновления от сервера
      once("purchaseSuccess", (data) => {
        audioManager.play("s_coins"); // Воспроизводим звук покупки

        const randomPhrase = Math.floor(Math.random() * shopBuyPhrases.length);
        setShopPhrase(t(shopBuyPhrases[randomPhrase]));

        const { items, ducks, dealDucks } = data;
        setShopBuyButtonDisabled(false);
        setSortedItems(items);

        dispatch({ type: "UPDATE_ITEMS", payload: items });
        if (currency === "ducks") {
          dispatch({ type: "UPDATE_DUCKS", payload: ducks });
        } else if (currency === "dealDucks") {
          dispatch({ type: "UPDATE_DEAL_DUCKS", payload: dealDucks });
        }

        console.log("Items successfully updated on server and local profile.");
        addToast(t(activeShopItem.title) + " " + t("received"), "info");
      });

      // Обработка ошибки на сервере
      once("purchaseError", ({ message }) => {
        setShopBuyButtonDisabled(false);
        setActiveShopItem(null);

        console.error("Error updating items on server:", message);

        const randomPhrase = Math.floor(
          Math.random() * shopNotEnoughPhrases.length
        );
        setShopPhrase(t(shopNotEnoughPhrases[randomPhrase]));

        audioManager.play("s_nope");
        addToast(t(message), "error");
      });
    } catch (error) {
      console.error("Error in purchaseItem:", error);
      setShopBuyButtonDisabled(false);
    }
  };

  const [shopPhrase, setShopPhrase] = useState(
    "пРИВ! дабро пожалть в лавку Эби"
  );

  const [activeShopItem, setActiveShopItem] = useState(null);
  const [activeShopItemInfo, setActiveShopItemInfo] = useState(null);
  const [activeShopItemQuantity, setActiveShopItemQuantity] = useState(1);
  const [shopBuyButtonDisabled, setShopBuyButtonDisabled] = useState(false);
  const [activeShopCategory, setActiveShopCategory] = useState({});
  const [activeShopPower, setActiveShopPower] = useState(1);
  const [activeShopSize, setActiveShopSize] = useState("S");
  const [choosenShopItem, setChoosenShopItem] = useState("Upgrade luck");

  const handleSizeClick = (size) => {
    setActiveShopSize(size);
    const choosenItem = getItemBySizeAndPower(
      activeShopCategory,
      size,
      activeShopPower
    );
    setActiveShopItem(choosenItem);
  };

  const handleItemClick = (item, index) => {
    console.log(item);
    setChoosenShopItem(item);
    setActiveShopItem(activeShopCategory.variants[index]);
  };

  const handlePowerClick = (power) => {
    setActiveShopPower(power);
    const choosenItem = getItemBySizeAndPower(
      activeShopCategory,
      activeShopSize,
      power
    );
    setActiveShopItem(choosenItem);
  };

  const chooseShopCategory = (item) => {
    setActiveShopCategory(item);
    if (item.variants) {
      setActiveShopItem(item.variants[0]);
    }
  };

  useEffect(() => {
    const currentItem = activeShopItem;
    async function fetchInfo() {
      const shopItemInfo = await getItemByName(currentItem.title);
      setActiveShopItemInfo(shopItemInfo);
    }
    if (currentItem != null) {
      fetchInfo();
    }
  }, [activeShopItem]);
  return (
    <>
      <div className="inventory-title">
        <div className="invenory-title-text">{t("AbigailPlace")}</div>
        <TakeIcon
          onClick={() => {
            setNowOpen("city");
            audioManager.stopAll();
            audioManager.play("s_city");
          }}
          className="back-icon"
          fill="#e0e0e0dc"
          size="20px"
        ></TakeIcon>
      </div>
      <div className="shop-image">
        <motion.div
          key={shopPhrase}
          initial={{ y: 20, rotate: -20 }}
          animate={{ y: 0, rotate: 0 }}
          className="shop-dialog"
        >
          {t(shopPhrase)}
        </motion.div>
      </div>
      <motion.div
        initial={{ x: 30, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        className="inventory-container add-ui-container"
      >
        {shopItems.length > 0 && (
          <div>
            <div className="shop-items-wrapper">
              {shopItems.map((item, index) => (
                <div
                  style={{ backgroundColor: item.color }}
                  key={index}
                  onClick={() => {
                    setActiveShopItem(item);
                    chooseShopCategory(item);
                    audioManager.play("s_buttonClick");
                  }}
                  className="shop-item-container"
                >
                  <img
                    className="shop-item-img"
                    src={item.miniimg}
                    alt="miniaura"
                  ></img>
                  <div className="shop-item-title">{t(item.title)}</div>
                </div>
              ))}
            </div>
          </div>
        )}
      </motion.div>
      {activeShopItem != null && (
        <>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            className="buy-confirm-window"
          >
            <div className="buy-confirm-wrapper">
              <div
                onClick={() => {
                  setActiveShopItem(null);
                  setActiveShopItemQuantity(1);
                  setChoosenShopItem(null);
                  setActiveShopPower(1);
                  setActiveShopSize("S");
                }}
                style={{
                  position: "absolute",
                  top: 15,
                  right: 20,
                  fontSize: 18,
                }}
              >
                ✖
              </div>
              <div
                style={{
                  fontSize: 12,
                  opacity: 0.5,
                  marginBottom: "30px",
                  textTransform: "uppercase",
                }}
              >
                {t("Purchase details")}
              </div>
              <img
                src={activeShopItem.miniimg}
                width={"120px"}
                style={{ borderRadius: 8 }}
                alt="activeShopItem mini img"
              ></img>
              <div style={{ textAlign: "center" }}>
                <div style={{ marginBottom: "5px" }}>
                  {t(activeShopItem.title)}
                </div>
                {activeShopItem.description && (
                  <div style={{ color: "yellow" }}>
                    {t(activeShopItem.description)}
                  </div>
                )}
                <div style={{ color: "yellow" }}>
                  {activeShopItemInfo?.multiplyer > 0 && (
                    <div>
                      {t("luck")} +{activeShopItemInfo.multiplyer} <br />
                      {t("duration")} {activeShopItemInfo.timer} {t("min")}
                    </div>
                  )}
                  {activeShopItemInfo?.speedBonus > 0 && (
                    <div>
                      {t("spin time")} -{activeShopItemInfo.speedBonus / 1000}{" "}
                      {t("sec")} <br />
                      {t("duration")} {activeShopItemInfo.timer} {t("min")}
                    </div>
                  )}
                </div>
              </div>
              {activeShopCategory.type === "item" && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "20px",
                  }}
                >
                  <button
                    onClick={() => {
                      if (activeShopItemQuantity > 1) {
                        audioManager.play("s_buttonClick");

                        setActiveShopItemQuantity((current) => current - 1);
                      }
                    }}
                    className="buy-buttons"
                  >
                    -
                  </button>
                  <div className="buy-confirm-quantity">
                    {activeShopItemQuantity}
                  </div>
                  <button
                    onClick={() => {
                      audioManager.play("s_buttonClick");
                      if (activeShopItemQuantity < 50) {
                        setActiveShopItemQuantity((current) => current + 1);
                      }
                    }}
                    className="buy-buttons"
                  >
                    +
                  </button>
                </div>
              )}
              <div className="shop-variants-wrapper">
                {activeShopCategory.sizes && (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div className="shop-variants-title">{t("Size")}</div>
                    <div className="shop-variants">
                      {activeShopCategory.sizes.map((size) => (
                        <div
                          key={size}
                          className={`shop-variant ${
                            activeShopSize === size ? "variant-selected" : ""
                          }`}
                          onClick={() => handleSizeClick(size)}
                        >
                          {size}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {activeShopCategory.stars && (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div className="shop-variants-title">{t("Power")}</div>
                    <div className="shop-variants">
                      {activeShopCategory.stars.map((stars) => (
                        <div
                          key={stars}
                          className={`shop-variant ${
                            activeShopPower === stars ? "variant-selected" : ""
                          }`}
                          onClick={() => handlePowerClick(stars)}
                        >
                          {stars}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {activeShopCategory.items && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <div className="shop-variants">
                      {activeShopCategory.items.map((item, index) => (
                        <div
                          key={index}
                          className={`shop-variant ${
                            choosenShopItem === item ? "variant-selected" : ""
                          }`}
                          onClick={() => handleItemClick(item, index)}
                        >
                          {t(item)}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
              <Divider />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 8,
                  justifyContent: "center",
                  alignItems: "center",
                  transform: "translateY(-3px)",
                }}
              >
                {t("Total: ")}
                <motion.div
                  key={activeShopItemQuantity}
                  initial={{ scale: 1.1 }}
                  animate={{ scale: 1 }}
                  style={{
                    display: "flex",
                    gap: "7px",
                    alignItems: "center",
                  }}
                >
                  {activeShopItem.cost > 0 && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "4px 8px",
                        gap: 4,
                        fontSize: 20,
                        borderRadius: 8,
                      }}
                    >
                      {activeShopItem.cost * activeShopItemQuantity}
                      <DucksIcon size={"20px"} />
                    </div>
                  )}
                  {activeShopItem.cost > 0 && (
                    <div style={{ opacity: 0.5 }}>{t("OR")}</div>
                  )}

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "4px 8px",
                      gap: 4,
                      fontSize: 20,
                      borderRadius: 8,
                    }}
                  >
                    {activeShopItem.ddCost * activeShopItemQuantity}
                    <DealDucksIcon size={"20px"} />
                  </div>
                </motion.div>
              </div>

              <div
                style={{
                  display: "flex",
                  width: "100%",
                  gap: 10,
                }}
              >
                {activeShopItem.cost > 0 && (
                  <button
                    disabled={shopBuyButtonDisabled}
                    onClick={() => handleBuy("ducks")}
                    className="button-buy"
                    style={{
                      backgroundColor: "#F8D423",
                      fontSize: 16,
                      fontWeight: 600,
                    }}
                  >
                    {t("Buy for DUCK$")}
                  </button>
                )}

                <button
                  disabled={shopBuyButtonDisabled}
                  onClick={() => handleBuy("dealDucks")}
                  style={{
                    backgroundColor: "rgb(132, 70, 255)",
                    fontSize: 16,
                    fontWeight: 600,
                  }}
                  className="button-buy"
                >
                  {t("Buy for DealDUCK$")}
                </button>
              </div>
            </div>
          </motion.div>
          <div
            onClick={() => {
              setActiveShopItem(null);
              setActiveShopItemQuantity(1);
              setActiveShopPower(1);
              setActiveShopSize("S");
            }}
            className="black-screen"
          ></div>
        </>
      )}
    </>
  );
};

export default Shop;
